export enum AuditFieldworkWorkflowStepCommentType {
    None = 0,
    New = 10,
    InReview = 20,
    Approved = 30,
    Rejected = 40,
    Reopened = 50,
}
